import { useCallback } from 'react';
import useAnalytics from '../../../../../analytics/useAnalytics';
import { VIDEO_LABELLING_EVENT_NAMES } from './event-name';
import type { AnnotationInterpolatePayloadT, AnnotationTimelineSelectionPayloadT, ChangeVideoPayloadT, VideoFrameNumberInputPayloadT, VideoFrameSelectPayloadT, VideoLoadPayloadT, VideoPlayerControlsPayloadT, VideoSAMTrackPayloadT } from './types';
const useAnalyticsForVideoLabelling = () => {
  const {
    sendEvent
  } = useAnalytics();
  const sendEventVideoPlayerControls = useCallback((payload: VideoPlayerControlsPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.VIDEO_PLAYER_CONTROLS,
      payload
    });
  }, [sendEvent]);
  const sendEventVideoFrameSelect = useCallback((payload: VideoFrameSelectPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.VIDEO_FRAME_SELECT,
      payload
    });
  }, [sendEvent]);
  const sendEventVideoFrameNumberInput = useCallback((payload: VideoFrameNumberInputPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.VIDEO_FRAME_NUMBER_INPUT,
      payload
    });
  }, [sendEvent]);
  const sendEventAnnotationTimelineSelection = useCallback((payload: AnnotationTimelineSelectionPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.ANNOTATION_TIMELINE_SELECTION,
      payload
    });
  }, [sendEvent]);
  const sendEventAnnotationInterpolateSave = useCallback((payload: AnnotationInterpolatePayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.ANNOTATION_INTERPOLATE_SAVE,
      payload
    });
  }, [sendEvent]);
  const sendEventAnnotationInterpolateDelete = useCallback((payload: AnnotationInterpolatePayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.ANNOTATION_INTERPOLATE_DELETE,
      payload
    });
  }, [sendEvent]);
  const sendEventVideoSAMTrack = useCallback((payload: VideoSAMTrackPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.VIDEO_SAM_TRACK,
      payload
    });
  }, [sendEvent]);
  const sendEventChangeVideo = useCallback((payload: ChangeVideoPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.CHANGE_VIDEO,
      payload
    });
  }, [sendEvent]);
  const sendEventVideoLoad = useCallback((payload: VideoLoadPayloadT) => {
    sendEvent({
      action: VIDEO_LABELLING_EVENT_NAMES.VIDEO_LABELING_LOAD,
      payload
    });
  }, [sendEvent]);
  return {
    sendEventVideoLoad,
    sendEventVideoPlayerControls,
    sendEventVideoFrameNumberInput,
    sendEventAnnotationTimelineSelection,
    sendEventAnnotationInterpolateSave,
    sendEventAnnotationInterpolateDelete,
    sendEventVideoFrameSelect,
    sendEventVideoSAMTrack,
    sendEventChangeVideo
  };
};
export default useAnalyticsForVideoLabelling;